import React from "react";
import { createRoot } from "react-dom/client";
import _ from "lodash";

const roots = new Map();

export default function ReactComponentRegister(component, ComponentModule) {
  let Component = ComponentModule.default;

  jQuery(function () {
    jQuery('[js-react="' + component + '"]').each(function () {
      let $el = $(this);
      let reactProps;

      if (component.indexOf("help/index.jsx") != -1) {
        if (typeof isInCourse === "undefined" || !isInCourse) {
          reactProps = JSON.parse(
            '{ "addClass": "header-icon", "sectionId":"' +
              getSectionId() +
              '"}',
          );
        } else {
          reactProps = JSON.parse('{ "addClass": "header-icon"}');
        }
      } else {
        reactProps = JSON.parse($el.attr("js-props") || "{}");
      }

      $el.click(
        (e) =>
          $(e.target).closest("button").addBack("button").length &&
          e.preventDefault(),
      );

      let root = roots.get(this);

      if (!root) {
        root = createRoot(this);
        roots.set(this, root);
      }

      root.render(<Component {...reactProps} />);
    });
  });

  function getSectionId() {
    let sectionId;

    if (!luvit.GetQueryString("sectionid")) {
      const url = window.location.href;

      sectionId = url.toLowerCase().replace(/^https?:\/\/.*?\//i, "/");
      sectionId = sectionId.replace("#", "");
      let urlRoot = __LUVITCONFIG.urlRoot.toLowerCase();
      let i = sectionId.indexOf(urlRoot);
      if (i >= 0) sectionId = sectionId.substr(i + urlRoot.length);

      sectionId = sectionId.replace(/\//g, "").replace(".aspx", "");

      i = sectionId.indexOf("?");
      if (i >= 0) sectionId = sectionId.substring(0, i);

      return sectionId;
    } else {
      return luvit.GetQueryString("sectionid");
    }
  }
}
